export const FETCHING = 'cardlists/FETCHING'
export const FETCHING_ERROR = 'cardlists/FETCHING_ERROR'
export const FETCHING_SUCCESS = 'cardlists/FETCHING_SUCCESS'
export const FETCHING_MORE = 'cardlists/FETCHING_MORE'
export const FETCHING_MORE_ERROR = 'cardlists/FETCHING_MORE_ERROR'
export const FETCHING_MORE_SUCCESS = 'cardlists/FETCHING_MORE_SUCCESS'
export const INIT_STORE = 'cardlists/INIT_STORE'
export const SUBMIT_FILTERS = 'cardlists/SUBMIT_FILTERS'
